// extracted by mini-css-extract-plugin
export default {"chat_wrapper":"ChatScreen_chat_wrapper__DcUUH","only_notactive":"ChatScreen_only_notactive__hVcCL"};